<template>
    <div class="sticky top-0 z-40">
      <div class="w-full h-20 px-6 border-b flex items-center justify-between">
        <!-- left navbar -->
        <div class="flex">
          <!-- mobile hamburger -->
          <div class="lg:hidden flex items-center mr-4">
            <button class="hover:text-blue-500 hover:border-white focus:outline-none navbar-burger" @click="toggleSidebarComponent()">
              <svg class="h-5 w-5" v-bind:style="{ fill: 'black' }" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z"/></svg>
            </button>
          </div>
        </div>
        <!-- right navbar -->
        <div class="flex items-center relative gap-2">
          <h4 class="text-lg font-semibold">Xin chào, {{ entry.name }}!</h4>
          <div class="rounded-full border-2 hover:border-prime-color" @click="()=>{openUserMenu=!openUserMenu}">
            <img :src="$addPrefix(entry.image)" @error="replaceBrokenImage" class="w-12 h-12 rounded-full shadow-lg object-cover">
          </div>
        </div>
      </div>
      <vue-page-transition name="fade">
        <div class="absolute top-20 right-0 bg-white shadow-md shadow-black/25" v-show="openUserMenu">
          <p @click="userInfo" class="block px-5 md:px-6 py-2 hover:bg-gray-200 text-center">Thông tin tài khoản</p>
          <p @click="logout" class="block px-5 md:px-6 py-2 hover:bg-gray-200 text-center">Đăng xuất</p>
          <hr>
          <p @click="redirectToHome" class="block px-5 md:px-6 py-2 hover:bg-gray-200 text-center">Quay về trang chủ</p>
        </div>
      </vue-page-transition>
    </div>
</template>
    
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'Navbar',
    computed: {
        ...mapGetters('admin', ['sideBarOpen'])
    },
    data() {
        return {
          openUserMenu: false,
          entry: {}
        }
    },
    methods: {
      ...mapActions('user', ['GetUser']),
      ...mapActions('admin', ['toggleSidebar']),
      async toggleSidebarComponent() {
        await this.toggleSidebar()
      },
      async logout() {
        this.openUserMenu = false
        await localStorage.removeItem("loginStatus")
        await localStorage.removeItem("userId")
        this.$router.push({name: 'auth'})
      },
      userInfo() {
        this.openUserMenu = false
        this.$router.push({
          name: "admin.user.edit",
          params: { id: localStorage.getItem('userId')}
        });
      },
      redirectToHome() {
        this.$router.push({
          name: "user.home",
        });
      },
      replaceBrokenImage(event) {
        event.target.src = require("@/assets/img/error/user-no-image.jpg");
      },
    },
    async created() {
      let response = await this.GetUser(localStorage.getItem("userId"))
      if (response.code == 200) {
        this.entry = response.data
      } else {
        this.logout()
      }
    }
}
</script>
    
<style lang="scss" scoped>

</style>
    